module.exports = __webpack_public_path__ + "img/cocobank-logo.5ac489b0.png";